import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TaskItem from './TaskItem';
import CustomScrollbars from './CustomScrollbars';

class TasksListForEdit extends Component {
	render () {
		const { list, loading } = this.props;

		return (
			<CustomScrollbars autoHeight autoHeightMin={100} autoHeightMax={300}>
				<ul className="task-list">
					{
						list.map((task, key) =>
							<TaskItem
								key={key}
								item={task}
								loadTasksFinished={this.props.loadTasksFinished}
								onRemoveTask={this.props.onRemove}
								loading={loading}
								isForAdmin
							/>
						)
					}
				</ul>
			</CustomScrollbars>
		);
	}
}

TasksListForEdit.propTypes = {
	onRemove: PropTypes.func.isRequired,
	list: PropTypes.array,
	loading: PropTypes.func,
	loadTasksFinished: PropTypes.func
};

TasksListForEdit.defaultProps = {
	list: []
}

export default TasksListForEdit;


// WEBPACK FOOTER //
// ./components/TasksListForEdit.js